/* eslint-disable @typescript-eslint/no-explicit-any */
import { ButtonVariants } from '@dcxwam/dcx-wam-ui-foundations'
import {
  addToCart,
  getToken,
  createCart,
  handleApiResponse,
  getCart,
  clearCart
} from '../../../../services/product/cart-flow'
import {
  pushDataLayerDisplayMiniCart,
  pushDataLayerAddToCartEvent
} from '../datalayer/methods'
import { getUserLoyaltyTier } from '../../../../services/user/user-data'
import { SETUPTIME_CORESITE_LOCALSTORAGE } from '../../../../utils/constants'

export const handleWrongOrderType: (props: {
  username: string
  token: string
  guid: string
  apiUrl: string
  setDialogErrorMessageIsOpen: (arg: boolean) => void
  addToCartProps: any
  baseSiteId: string
  language: string
}) => void = async ({ ...props }) => {
  const {
    username,
    token,
    guid,
    apiUrl,
    setDialogErrorMessageIsOpen,
    addToCartProps,
    baseSiteId,
    language
  } = props
  try {
    await clearCart({
      username,
      token,
      guid,
      apiUrl,
      baseSiteId
    })
    await createCart({
      username,
      token,
      apiUrl,
      language,
      baseSiteId
    })
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    await handleAddToCart({ ...addToCartProps })
    setDialogErrorMessageIsOpen(false)
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('clear cart API error')
  }
}

export const handleAddToCart = async ({ ...props }) => {
  const {
    setIsButtonDisabled,
    setIsButtonLoading,
    orderTypes,
    productID,
    isLoginUser,
    errorContent,
    setErroMessageContent,
    currentProductVariant,
    productQuantity,
    hybrisConfig,
    mulesoftConfig,
    market,
    setCookie,
    cookies,
    CORESITE_LOCALSTORAGE,
    language,
    setDialogErrorMessageIsOpen,
    cartLocalStorageJSON,
    setCartLocalStorage,
    setActiveMiniCart,
    defaultErrorMessage,
    dataLayerEcommerceProduct
  } = props

  const hybrisApiUrl = hybrisConfig?.CA_HYBRIS_URL
  const hybrisClientId = hybrisConfig?.CA_CLIENT_ID
  const hybrisClientSecret = hybrisConfig?.CA_CLIENT_SECRET
  const hybrisCookieName = hybrisConfig?.HYBRIS_ACCESS_TOKEN
  const hybrisBaseSiteId = hybrisConfig?.CA_HYBRIS_BASE_SITE_ID
  const hybrisLanguage = hybrisConfig?.CA_HYBRIS_LANGUAGE
    ? hybrisConfig?.CA_HYBRIS_LANGUAGE
    : language

  let username = null
  let token = null
  let guid = null
  const productCode = { code: productID }
  const quantity = productQuantity

  setIsButtonDisabled(true)
  setIsButtonLoading?.(true)
  try {
    const tokenCreds = {
      username,
      apiUrl: hybrisApiUrl,
      clientId: hybrisClientId,
      clientSecret: hybrisClientSecret,
      setCookie,
      cookieName: hybrisCookieName
    }

    const cartStorage = window.localStorage?.getItem(CORESITE_LOCALSTORAGE)
    const cartData = cartStorage && JSON.parse(cartStorage)
    const cartDataProductEntries = cartData?.cart?.entries

    const productInCart = cartDataProductEntries?.find(
      (entry: any) => entry?.product?.code === productID
    )

    if (cookies.gig_uid) {
      username = atob(cookies.gig_uid)
    } else {
      username = 'anonymous'
    }
    if (cookies.hy_at) {
      token = atob(cookies.hy_at)
    } else {
      token = await getToken({
        ...tokenCreds
      })
    }

    // GUEST or new user
    if (username === 'anonymous' || !cartData) {
      if (cartData?.cart?.guid) {
        guid = cartData?.cart?.guid
      } else if (token) {
        const { cartCreateRes } = await createCart({
          username,
          token,
          apiUrl: hybrisApiUrl,
          language: hybrisLanguage,
          baseSiteId: hybrisBaseSiteId
        })

        const { newToken, responseJson } = await handleApiResponse({
          response: cartCreateRes,
          ...tokenCreds
        })

        if (newToken) {
          const { cartCreateRes: cartCreateResNew } = await createCart({
            username,
            token: newToken,
            apiUrl: hybrisApiUrl,
            language: hybrisLanguage,
            baseSiteId: hybrisBaseSiteId
          })
          token = newToken
          const newGuid = await cartCreateResNew?.json()
          guid = newGuid?.guid
        } else if (username === 'anonymous') {
          guid = responseJson?.guid
        } else {
          guid = responseJson?.code
        }
      } else {
        setErroMessageContent({
          message: null,
          title: defaultErrorMessage,
          actions: null
        })
        setDialogErrorMessageIsOpen(true)
      }
    } else {
      // LOGIN USER
      // eslint-disable-next-line no-lonely-if
      if (cartData?.cart?.guid) {
        guid = cartData?.cart?.code
      } else {
        const { getCartRes } = await getCart({
          username,
          token,
          apiUrl: hybrisApiUrl,
          language: hybrisLanguage,
          baseSiteId: hybrisBaseSiteId
        })
        const res = await handleApiResponse({
          response: getCartRes,
          ...tokenCreds
        })
        const { newToken, responseJson, notFound } = res

        if (newToken) {
          const { getCartRes: getCartResNew } = await getCart({
            username,
            token: newToken,
            apiUrl: hybrisApiUrl,
            language: hybrisLanguage,
            baseSiteId: hybrisBaseSiteId
          })
          token = newToken
          const newGuid = await getCartResNew?.json()
          guid = newGuid?.carts?.[0]?.code
        } else if (notFound || Object.keys(responseJson).length === 0) {
          const { cartCreateRes: cartCreateResNew } = await createCart({
            username,
            token,
            apiUrl: hybrisApiUrl,
            language: hybrisLanguage,
            baseSiteId: hybrisBaseSiteId
          })
          const newGuid = await cartCreateResNew?.json()
          guid = newGuid?.code
        } else {
          guid = responseJson?.carts?.[0]?.code
        }
      }
    }

    const isOrderTypeCorrect = orderTypes?.includes(
      cartData?.cart?.orderType?.typeId
    )

    if (
      currentProductVariant?.loyaltyLevel &&
      currentProductVariant.loyaltyLevel.length &&
      !isLoginUser
    ) {
      setErroMessageContent({
        title: errorContent?.loginRequiredTitle,
        message: errorContent?.loginRequiredMessage,
        actions: [
          {
            label: errorContent?.loginRequiredCTALabel,
            linkUrl: errorContent?.loginPageURL
          }
        ],
        dismissible: true
      })
      setDialogErrorMessageIsOpen(true)
    } else if (
      cartData &&
      cartData?.cart?.orderType?.typeId &&
      cartData?.cart?.totalItems > 0 &&
      !isOrderTypeCorrect
    ) {
      setErroMessageContent({
        title: errorContent?.differentOrderTypeTitle,
        message: errorContent?.differentOrderTypeMessage,
        actions: [
          {
            label: errorContent?.differentOrderTypeConfirmCTALabel,
            onClick: async () => {
              handleWrongOrderType({
                username,
                token,
                guid,
                apiUrl: hybrisApiUrl,
                baseSiteId: hybrisBaseSiteId,
                language: hybrisLanguage,
                setDialogErrorMessageIsOpen,
                addToCartProps: props
              })
            }
          },
          {
            label: errorContent?.addToCartDialogCancelCTALabel,
            buttonVariant: ButtonVariants.Outlined,
            onClick: () => setDialogErrorMessageIsOpen(false)
          }
        ]
      })
      setDialogErrorMessageIsOpen(true)
    } else if (
      Number(productInCart?.quantity) + Number(quantity) >
      productInCart?.product?.maxOrderQuantity
    ) {
      setErroMessageContent({
        title: errorContent?.exceededMaximumQuantityTitle,
        message: errorContent?.exceededMaximumQuantityMessage
      })
      setDialogErrorMessageIsOpen(true)
    } else if (token && guid) {
      if (
        currentProductVariant?.loyaltyLevel &&
        currentProductVariant.loyaltyLevel.length
      ) {
        // fetch user loyalty tier
        const userLoyaltyTier = await getUserLoyaltyTier({
          clientId: mulesoftConfig?.clientId,
          clientSecret: mulesoftConfig?.clientSecret,
          apiUrl: mulesoftConfig?.url,
          countryIsoCode: market?.toUpperCase(),
          consumerId: cookies.gig_uid ? atob(cookies.gig_uid) : '',
          jwtToken: cookies.gig_jwt,
          channel: mulesoftConfig?.xChannel
        })

        if (userLoyaltyTier?.result) {
          const productLoyaltyIncludesUserLoyalty =
            currentProductVariant?.loyaltyLevel.some(
              (level: string) =>
                level.toLocaleLowerCase() ===
                userLoyaltyTier.result?.toLowerCase()
            )
          if (!productLoyaltyIncludesUserLoyalty) {
            setErroMessageContent({
              title: errorContent?.differentLoyaltyRequiredTitle,
              message: errorContent?.differentLoyaltyRequiredMessage
            })
            setDialogErrorMessageIsOpen(true)
            return
          }
        } else {
          setErroMessageContent({
            title: errorContent?.differentLoyaltyRequiredTitle,
            message: errorContent?.differentLoyaltyRequiredMessage
          })
          setDialogErrorMessageIsOpen(true)
          return
        }
      }

      const { cartAddRes } = await addToCart({
        username,
        guid,
        token,
        product: productCode,
        quantity,
        apiUrl: hybrisApiUrl,
        language: hybrisLanguage,
        baseSiteId: hybrisBaseSiteId
      })

      const {
        newToken: newTokenAddToCart,
        responseJson: responseJsonAddToCart,
        errorJson: errorJsonAddToCart
      } = await handleApiResponse({
        response: cartAddRes,
        ...tokenCreds
      })

      const setCartSetupTime = () => {
        localStorage.setItem(
          SETUPTIME_CORESITE_LOCALSTORAGE,
          Date.now().toString()
        )
      }

      if (errorJsonAddToCart) {
        setErroMessageContent({
          message: null,
          title: defaultErrorMessage,
          actions: null
        })
        setDialogErrorMessageIsOpen(true)
      } else if (newTokenAddToCart) {
        const { cartAddRes: cartAddResNew } = await addToCart({
          username,
          guid,
          token: newTokenAddToCart,
          product: productCode,
          quantity,
          apiUrl: hybrisApiUrl,
          language: hybrisLanguage,
          baseSiteId: hybrisBaseSiteId
        })
        const { responseJson: newresponseJsonAddToCart } =
          await handleApiResponse({
            response: cartAddResNew,
            ...tokenCreds
          })

        if (newresponseJsonAddToCart) {
          const newCartLocalStorageValue = {
            ...cartLocalStorageJSON,
            ...newresponseJsonAddToCart
          }
          setCartLocalStorage(JSON.stringify(newCartLocalStorageValue))
          setCartSetupTime()
          setActiveMiniCart(true)
          pushDataLayerDisplayMiniCart()
          pushDataLayerAddToCartEvent(dataLayerEcommerceProduct)
        } else {
          setErroMessageContent({
            message: null,
            title: defaultErrorMessage,
            actions: null
          })
          setDialogErrorMessageIsOpen(true)
        }
      } else {
        const newCartLocalStorageValue = {
          ...cartLocalStorageJSON,
          ...responseJsonAddToCart
        }
        setCartLocalStorage(JSON.stringify(newCartLocalStorageValue))
        setCartSetupTime()
        setActiveMiniCart(true)
        pushDataLayerDisplayMiniCart()
        pushDataLayerAddToCartEvent(dataLayerEcommerceProduct)
      }
    } else {
      setErroMessageContent({
        message: null,
        title: defaultErrorMessage,
        actions: null
      })
      setDialogErrorMessageIsOpen(true)
    }
  } finally {
    setIsButtonDisabled(false)
    setIsButtonLoading?.(false)
  }
}
